function thousandSeparator (num) {
  const numParts = num.toString().split('.')
  numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return numParts.join('.')
}

export default function ({ projectClasses }) {
  const wTaxAmounts = []
  for (const obj of projectClasses) {
    if (obj.apv) {
      const { wTax } = obj?.apv
      wTaxAmounts.push(wTax)
    }
  }
  const wTax = wTaxAmounts.reduce((a, b) => a + b, 0).toFixed(2)
  return thousandSeparator(wTax.toString())
}
